var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hb-metric" }, [
    _c("div", { staticClass: "hb-metric__label" }, [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "hb-metric__value" },
      [
        _vm._t("default", function () {
          return [_vm._v(_vm._s(_vm.value))]
        }),
      ],
      2
    ),
    _vm.hasDelta
      ? _c(
          "div",
          { staticClass: "hb-metric__delta", class: _vm.deltaClass },
          [
            _c("feather-icon", {
              attrs: {
                icon: _vm.deltaUp ? "ArrowUpIcon" : "ArrowDownIcon",
                size: "12",
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.deltaLabel))]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }